import { FormControl, type ValidatorFn, Validators } from '@angular/forms';
import { whitespaceValidator } from '../validators/whitespace.validator';
import { trimmedMinLengthValidator } from '../validators/trimmed-min-length.validator';

interface CreateTextControlOptions {
  defaultValue?: string;
  required?: boolean;
  maxLength?: number;
  minLength?: number;
  validators?: ValidatorFn[];
}

export function createTextControl({
  defaultValue = '',
  required = true,
  minLength = 0,
  maxLength = 255,
  validators = [],
}: CreateTextControlOptions = {}): FormControl<string> {
  return new FormControl(defaultValue, {
    validators: [
      ...(required ? [Validators.required] : []),
      whitespaceValidator(),
      Validators.maxLength(maxLength),
      trimmedMinLengthValidator(minLength),
      ...validators,
    ],
    nonNullable: true,
  });
}
